import { render, staticRenderFns } from "./CmgLoadingPepper.vue?vue&type=template&id=1aa2195a&scoped=true&lang=pug"
import script from "./cmg-loading-pepper.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loading-pepper.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoadingPepper.vue?vue&type=style&index=0&id=1aa2195a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2195a",
  null
  
)

export default component.exports